import Vue from 'vue';
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator';
import { ED_MODAL_EVENTS } from '../../ed-modal.plugin';
import KEYS from '@/values/keys';

@Component({})
export default class EdModalMessage extends Vue {

  /* Arguments */
  @Prop() readonly params: any;

  /* Data */
  public title: string = '';
  public body: string = '';
  public icon: string = '';
  public type: string = '';
  public action: Function = ()=>{};
  public showAction : boolean = true;

  /* Computed */
  get classes() { 
    return { 
      'ed-modal-message--danger': this.type == KEYS.EVENT_TYPES.DANGER,
      'ed-modal-message--success': this.type == KEYS.EVENT_TYPES.SUCCESS,
      'ed-modal-message--warning': this.type == KEYS.EVENT_TYPES.WARNING
    }; 
  }

  /* Methods */
  public closeModal() {
    this.$EdModal.$emit(ED_MODAL_EVENTS.ED_MODAL_MESSAGE_HIDE);
  }

  public actionModal() {
    this.$EdModal.$emit(ED_MODAL_EVENTS.ED_MODAL_MESSAGE_HIDE);
    this.action();
  }

  public created() {
    this.body = this.params.body;
    this.title = this.params.title;
    this.icon = this.params.icon;
    this.type = this.params.type;
    if(this.params.action){
      this.action = this.params.action;
    }
    this.showAction = this.params.showAction !== false;
  }
}